// extracted by mini-css-extract-plugin
module.exports = {"navbar":"_css_navbar__64YTA","collapsed":"_css_collapsed__sd5gz","collapseButton":"_css_collapseButton__ki9Yq","section":"_css_section__TLkt7"};